import React from 'react';
import { DataReconciliationTableHeader } from './components/DataReconciliationTableHeader';
import { TableBody, TableRow, TableWrapper } from '../../CommonComponents/OPL/Table/Table';
import { Text } from '../../CommonComponents/OPL/Text/Text';

export const DataReconciliationTableEmpty = () => {
  return (
    <TableWrapper variant="noTitle">
      <DataReconciliationTableHeader />

      <TableBody>
        <TableRow>
          <Text color="neutral.600">You have not added any accounts.</Text>
        </TableRow>
      </TableBody>
    </TableWrapper>
  );
};
